module.exports = __webpack_public_path__ + "static/media/localguide.b7f903d7.png";